module.exports = __webpack_public_path__ + "static/media/mountains.241ecb84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/AttractLoopView/mountains.svg
// module id = 877
// module chunks = 0